<template>
  <div id="svg-container">
    <svg :id="id"></svg>
    <div class="mt-auto" style="background-color: transparent;">
      <div class="row">
        <div class="col-lg-1">
          <!-- pulsante prev -->
          <div style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="prevMethod" ><i class="fa fa-angle-left" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);"></i>&nbsp;PREV</div>
        </div>
        <div class="col-lg-2">
          <!-- spazio vuoto a sinistra della scrollbar/slider -->
        </div>
        <div class="col-lg-6">
          <svg :id="`scroll_${id}`"></svg>
        </div>
        <div class="col-lg-2">
          <div v-if="!(globalBarWidth == maxZoom && !isScroll)">
            <!-- zoom -->
            <i class="fa fa-search-minus" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="zoomOut" v-if="globalBarWidth > minZoom"></i>
            <span style="color: rgb(54, 96, 121);">&nbsp;ZOOM&nbsp;</span>
            <i class="fa fa-search-plus" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="zoomIn" v-if="globalBarWidth < maxZoom"></i>
          </div>
        </div>
        <div class="col-lg-1">
          <!-- pulsante next -->
          <div style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="nextMethod" >NEXT&nbsp;<i class="fa fa-angle-right" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";
import jquery from 'jquery';

const margin = {top: 50, right: 50, bottom: 50, left: 50};
const aliasBarPrefix = "alias#";

export default {
  props: ["models","graphicTitle","router","propertyName","filtroRicerca","yUm","prevMethod","nextMethod","labelInclination","filterDB","code","transpose","colors"],
  data() {
    return {
      id: null,
      chart: null,
      scrollChart: null,
      isScroll: null,
      noDataSentence: null,
      globalBarWidth: null,
      minZoom: 25,
      maxZoom: 35,
      jquery,
      svg: null,
      svgScroll: null,
      scrollTotalWidth: null,
      totalWidth: null,
      doRender: false,
    };
  },
  watch: {
    models(val) {
      if (this.chart != null) this.chart.remove();
      if (this.scrollChart != null) this.scrollChart.remove();
      if (this.noDataSentence != null) this.noDataSentence.remove();
      this.renderChart();
    }
  },
  methods: {
    renderChart() {
      const chartId = this.id;

      // [{"model_name":"Min.   Media   Max.","min":"0","avg":"0","max":"0"}]
      this.doRender = false;
      if (this.models !== undefined) {
        this.models.forEach(m => {
          for (const [key, value] of Object.entries(m)) {
            if ((key == "min" || key == "avg" || key == "max") && value != "0") {
              this.doRender = true;
              break;
            }
          }
        });
      }

      if (this.transpose) {
      /*
        vm.models = [
          {"model_name":"anno_2020","min":"0.22","avg":"0.25","max":"3.11"},
          {"model_name":"anno_2021","min":"0.21","avg":"0.35","max":"3.15"},
          {"model_name":"anno_2022","min":"0.23","avg":"0.45","max":"3.16"},
          {"model_name":"anno_2023","min":"0.20","avg":"0.55","max":"3.18"},
        ]

      to

        this.elabmodels = [
          {"model_name":"Min.","anno_2020":"0.22","anno_2021":"0.21","anno_2022":"0.23","anno_2023":"0.20"},
          {"model_name":"Media","anno_2020":"0.25","anno_2021":"0.35","anno_2022":"0.45","anno_2023":"0.55"},
          {"model_name":"Max.","anno_2020":"3.11","anno_2021":"3.15","anno_2022":"3.16","anno_2023":"3.18"},
        ];*/

        this.elabmodels = [
          {"model_name":"Min."},
          {"model_name":"Media"},
          {"model_name":"Max."},
        ];

        this.models.forEach((mitem) => {
          this.elabmodels.forEach((emitem) => {
            if (emitem.model_name == "Min.") {
              emitem[mitem.model_name] = mitem.min;
              emitem[aliasBarPrefix + mitem.model_name] = mitem.alias_model_name;
            }
            if (emitem.model_name == "Media") {
              emitem[mitem.model_name] = mitem.avg;
              emitem[aliasBarPrefix + mitem.model_name] = mitem.alias_model_name;
            }
            if (emitem.model_name == "Max.") {
              emitem[mitem.model_name] = mitem.max;
              emitem[aliasBarPrefix + mitem.model_name] = mitem.alias_model_name;
            }
          });
        });
      } else {
        this.elabmodels = this.models;
      }

      if (this.elabmodels !== undefined && this.elabmodels.length > 0) {
        const svgWidth = 1100;
        const svgHeight = 530;
        
        this.svg = d3
          .select("#" + this.id)
          .attr("class", "chart")
          .attr("width", "100%")
          .attr("height", "97%");
        
        this.svgScroll = d3
          .select("#scroll_" + this.id)
          .attr("class", "scrollchart-container")
          .attr("width", "100%")
          .attr("height", "20");

        jquery(".group-tooltip").remove();
        var tooltip = jquery("<div></div>").addClass("chart-tooltip group-tooltip");
        tooltip.hide();
        jquery("body").append(tooltip);

        if (this.chart) {
          this.chart.remove();
        }

        if (this.scrollChart) {
          this.scrollChart.remove();
        }

        window.addEventListener("resize", this.drawFunction);

        this.drawFunction();
      }
    },
    zoomed({transform}) {
      this._zoomed(transform);
    },
    _zoomed(transform) {
      transform.y = 0;
      d3.select("#" + this.id)
        .select("g")
        .attr("transform", transform);
    },
    display(event) {
      var x = parseInt(this.svgScroll.select(".mover").attr("x")),
        nx = x + event.dx,
        w = parseInt(this.svgScroll.select(".mover").attr("width"));
      if ( nx < 0 || nx + w > this.scrollTotalWidth ) return;
      this.svgScroll.select(".mover").attr("x", nx);

      var dx = -1 * parseInt((nx / this.scrollTotalWidth) * this.totalWidth);
      var t = d3.zoomIdentity.translate(margin.left + dx, 0).scale(1);
      this._zoomed(t);
    },
    drawFunction() {
      console.log("draw gbc " + this.graphicTitle);

      const xAxisKey = "model_name";
      let fieldsKeys = [];
      let yMax = 0;
      this.elabmodels.forEach(m => {
        for (const [key, value] of Object.entries(m)) {
          let yVal = Number(value);
          if (key !== xAxisKey &&
              !key.startsWith(aliasBarPrefix) &&
              !Number.isNaN(yVal)) {
            if (!fieldsKeys.includes(key)) {
              fieldsKeys.push(key);
            }
            if (yMax < yVal) {
              yMax = yVal;
            }
          }
        }
      });

      const barPadding = .2;
      const axisTicks = {qty: yMax, outerSize: 0};
      const items = this.elabmodels.length;

      let bounds = this.svg.node().getBoundingClientRect();

      if (bounds === undefined || bounds.width == 0 || bounds.height == 0) {
        return;
      }

      const chartWidth = bounds.width - (margin.left + margin.right);
      const chartHeight = bounds.height - (margin.top + margin.bottom);

      if (this.globalBarWidth === undefined || this.globalBarWidth === null) {
        this.globalBarWidth = this.maxZoom;
      }
      let barWidth = this.globalBarWidth * 3;

      this.svg.selectChild("g").remove();
      this.svg.selectChild("defs").remove(); 

      this.svgScroll.selectChild("g").remove();

      if (this.noDataSentence) {
        this.noDataSentence.remove();
      }
      if (!this.doRender) {
        this.noDataSentence = this.svg
          .append("text")
          .text("Non ci sono dati da rappresentare")
          .attr("x", chartWidth/2 + margin.right)
          .attr("y", chartHeight/2 - 2*margin.top)
          .style("font-size", "2rem")
          .style("fill", "#366079")
          .style("text-anchor", "middle");

        this.isScroll = false;
        this.svgScroll.attr("class", "no-scroll");

        return;
      }

      let xScaleRange = items * barWidth;
      let xRange = [chartWidth / 2 - xScaleRange, chartWidth / 2 + xScaleRange];
      if (xRange[0] < 0) {
        xRange[1] = xRange[1] - xRange[0];
        xRange[0] = 0;
      }          

      let xScale0 = d3.scaleBand().range(xRange).padding(barPadding);

      let xScale1 = d3.scaleBand();
      let yScale = d3.scaleLinear().range([chartHeight, 0]);

      let customcolors = undefined;
      if (this.colors) {
        customcolors = this.colors;
      } else {
        customcolors = ["#d9e6ee", "#679dba", "#366079"];
      }
      let colourScale = d3.scaleOrdinal()
        .range(customcolors);

      this.chart = this.svg
        .append("g")
        .attr("transform", `translate(${margin.left},0)`);

      this.scrollChart = this.svgScroll
        .append("g");

      let xAxis = d3.axisBottom(xScale0)
        .tickSizeOuter(axisTicks.outerSize);

      /*
      var yAxis = d3.axisLeft(yScale)
        .ticks(axisTicks.qty)
        .tickSizeOuter(axisTicks.outerSize)
        .tickFormat(d => d%tickLabelInterval==0 ? d + localYUm : "");
      */

      xScale0.domain(this.elabmodels.map(d => d[xAxisKey]));
      xScale1.domain(fieldsKeys).range([0, xScale0.bandwidth()]);
      yScale.domain([0, d3.max(this.elabmodels, d => yMax)]);

      let localYUm = this.yUm === undefined ? "" : this.yUm;
      const tickLabelInterval = Math.ceil(yMax/10);

      let model_name = this.chart.selectAll("." + xAxisKey)
        .data(this.elabmodels)
        .enter()
        .append("g")
        .attr("class", xAxisKey)
        .attr("transform", d => `translate(${xScale0(d[xAxisKey])},0)`);

      // Add bars
      const _propertyName = this.propertyName;
      const _code = this.code;
      const _filterDB = this.filterDB;
      fieldsKeys.forEach(function(xk) {
        model_name.selectAll(".bar." + xk)
          .data(d => [d])
          .enter()
          .append("rect")
          .attr("class", "bar " + xk)
          .style("fill",function(d) { return colourScale(xk); })
          .attr("x", d => xScale1(xk))
          .attr("y", function(d) {
            if (d[xk] == "N.A.") {
              return yScale(0);
            } 
            return yScale(d[xk]);
          })
          .attr("width", xScale1.bandwidth())
          .attr("height", d => {
            return chartHeight - yScale(d[xk]);
          })
          .on("mouseover", function(event, d) {
            d3.select(this)
              .attr("stroke-width", 3)
              .attr("stroke", "red")
              .attr("cursor","pointer");

            const aliasXk = d[aliasBarPrefix + xk] === undefined ? xk : d[aliasBarPrefix + xk];
            const t = `${d.model_name} - ${aliasXk} : ${d[xk]}${localYUm}`;
            jquery(".group-tooltip")
              .html(t)
              .css("left", (event.pageX) + "px")
              .css("top", (event.pageY - 28) + "px")
              .show(200);
          })
          .on("mouseout", function() {
            d3.select(this)
              .attr("stroke", "none")
              .attr("cursor","default");

            jquery(".group-tooltip").hide();
          })
          .on("click", (d,i) => {
            const _this = d.currentTarget;
            const isMin = _this.classList.contains("min");
            const isMax = _this.classList.contains("max");
            const isAvg = _this.classList.contains("avg");
            const barName = _this.classList[1];
            const barValue = i[barName];

            const description = i.description || i.model_name;
            var f = {
              key: _propertyName,
              value: {code: _code, description: description},
              min: isMin ? i.min : undefined,
              max: isMax ? i.max : undefined,
              avg: isAvg,
              barName: barName,
              barValue: barValue,
            };
            _filterDB(f);
          });

        model_name
          .selectAll("text .item-label-" + xk)
          .data(d => [d])
          .enter()
          .append("text")
          .attr("class", "item-label-" + xk)
          .text(function(d) {
            if (d[xk] == "N.A.") {
              return d[xk];
            }
            return d[xk] + localYUm;
          })
          .attr("x", function(d, i) {
            return xScale1(xk);
          })
          .attr("y", function(d) {
            const h = chartHeight - (d[xk] == "N.A." ? yScale(0) : yScale(d[xk]));
            if (d[xk] == "N.A.") {
              return yScale(0) - 10;
            } else if (h < 20) {
              return yScale(d[xk]) - 10;
            }
            return yScale(d[xk]) + 15;
          })
          .attr("dx", xScale1.bandwidth() / 2)
          .attr("font-size", "12px")
          .attr("fill", function (d) {
            const h = chartHeight - (d[xk] == "N.A." ? yScale(0) : yScale(d[xk]));
            if (h < 20 || xk === "min") {
              return "black";
            }
            return "white";
          })
          .attr("text-anchor", "middle")
          .attr("dominant-baseline", "central")
          .on("mouseover", function(event, d) {
            d3.select(this)
              .attr("cursor", "pointer");
          })
          .on("mouseout", function() {
            d3.select(this)
              .attr("cursor", "default");
          })          
          .on("click", (d,i) => {
            const _this = d.currentTarget;
            const isMin = _this.classList.contains("item-label-min");
            const isMax = _this.classList.contains("item-label-max");
            const isAvg = _this.classList.contains("item-label-avg");
            const barName = _this.classList[1];
            const barValue = i[barName];

            const description = i.description || i.model_name;
            var f = {
              key: _propertyName,
              value: {code: _code, description: description},
              min: isMin ? i.min : undefined,
              max: isMax ? i.max : undefined,
              avg: isAvg,
              barName: barName,
              barValue: barValue,
            };
            _filterDB(f);
          });
      });

      // Add the X Axis
      this.chart.append("g")
        .attr("class", "axis x-axis")
        .attr("transform", `translate(0,${chartHeight})`)
        .call(xAxis);

      // Add the Y Axis
      /*
      this.chart.append("g")
        .attr("class", "axis y-axis")
        .attr('transform', `translate(${xRange[0]}, 0)`)
        .call(yAxis);
      */

      // adding labels
      this.svg
        .append('text')
        .attr('class', 'label')
        .attr('x', -(chartHeight / 2) - margin.left)
        .attr('y', margin.top / 2.4)
        .attr('transform', 'rotate(-90)')
        .attr('text-anchor', 'middle')
        .text('')

      this.svg
        .append('text')
        .attr('class', 'label')
        .attr('x', chartWidth / 2 + margin.left)
        .attr('y', chartHeight + margin.top * 1.7)
        .attr('text-anchor', 'middle')
        .text('')

      /*this.svg
        .append('text')
        .attr('class', 'title')
        .attr('x', chartWidth / 2 + margin.left)
        .attr('y', 40)
        .attr('text-anchor', 'middle')
        .attr('stroke', '#366079')
        .style("text-shadow", "none")
        .text(graphicTitle)*/

      // legend
      /*let legendG = this.svg.selectAll(".legend")
        .attr("font-family", "sans-serif")
        .attr("font-size", 10)
        .attr("text-anchor", "end")
        .data(fieldsKeys.slice())
        .enter().append("g")
        .attr("transform", function(d, i) {
          return "translate(0," + i * 20 + ")";
        })
        .attr("class", "legend")

      legendG.append("rect")
        .attr("x", svgWidth - 15)
        .attr("y", 89)
        .attr("width", 15)
        .attr("height", 15)
        .attr("fill", colourScale )
        .attr("stroke-width",2)

      legendG.append("text")
        .attr("x", svgWidth - 50)
        .attr("y", 100)
        .text(function(d) { return d; });*/

      // insertLinebreaks
      /*
      let insertLinebreaks = function(d) {
        const maxRowChars = 15;

        if (typeof(d) === "string" && d.length > maxRowChars) {
          let el = d3.select(this);
          el.text('');

          let words1 = d.split(' ');

          let words2 = [];
          for (let i = 0; i < words1.length; i++) {
            if (words1[i].includes('+') ) {
              const words1Parts = words1[i].split('+');
              words1Parts.forEach(w => {
                words2.push(w);
                words2.push('+');
              });
              words2.pop();
            } else {
              words2.push(words1[i]);
            }
          }

          // aggrego le parole in modo che la loro concatenazione non superi maxRowChars
          let aggregateWords = [];
          let aggregateWordsIndex = 0;
          let concatWords = "";
          for (let i = 0; i < words2.length; i++) {
            let isLastIndex = (i == words2.length-1);

            let tempConcatWords = "";
            if (concatWords.length == 0) {
              tempConcatWords = words2[i];
            } else  {
              tempConcatWords = concatWords + " " + words2[i];
            }

            if (tempConcatWords.length > maxRowChars || isLastIndex) {
              aggregateWords[aggregateWordsIndex] = isLastIndex ? tempConcatWords : concatWords;
              aggregateWordsIndex++;
              concatWords = words2[i];
            } else {
              concatWords = tempConcatWords;
            }
          }

          for (let i = 0; i < aggregateWords.length; i++) {
            let tspan = el.append('tspan').text(aggregateWords[i]);
            if (i > 0)
              tspan.attr('x', 0).attr('dy', '15');
          }          
        }
      }
      */

      const zoom = d3.zoom()
        .scaleExtent([1, 40])
        .on("zoom", this.zoomed);

      // labelInclination
      let localLabelInclination = this.labelInclination;
      if (localLabelInclination === undefined || localLabelInclination === null) {
        localLabelInclination = true;
      }

      //this.svg.selectAll('g.tick text').each(insertLinebreaks);
      this.svg.selectAll('.x-axis g.tick text')
        .each(function() {
          const maxLabelLength = 25;
          let self = d3.select(this);
          let textLength = self.text().length;
          let text = self.text();
          if (textLength > maxLabelLength) {
            text = text.slice(0, maxLabelLength);
            self.text(text + '...');
          }
          if (text == "Min.   Media   Max.") {
            text = "";
            self.text(text);
          }
        })
        .attr("y", 0)
        .attr("x", () => {
          let shift = 10;
          if (!localLabelInclination) {
            shift = 0;
          }
          return shift;
        })
        .attr("dy", "1.5em")
        .attr("dx",  () => {
          let shift = "-0.5em";
          if (!localLabelInclination) {
            shift = "0em";
          }
          return shift;
        })
        .attr("transform", () => {
          let rotateVal = "rotate(15)";
          if (!localLabelInclination) {
            rotateVal = "rotate(0)";
          }
          return rotateVal;
        })
        .style("text-anchor", () => {
          let textAnchor = "start";
          if (!localLabelInclination) {
            textAnchor = "middle";
          }
          return textAnchor;
        });

      //this.svg.call(zoom);

      /*let lastBar = this.svg.selectAll(".model_name").filter(function() {
        console.log(this.nextElementSibling);
        return this.nextElementSibling.className.baseVal != "model_name";
        //return true;
      });

      console.log(lastBar.node().getBBox());
      */
      this.totalWidth = this.svg.select("g").node().getBBox().width;
      let scrollBounds = this.svgScroll.node().getBoundingClientRect();
      this.scrollTotalWidth = scrollBounds.width;
      let scrollWidth = chartWidth * this.scrollTotalWidth / this.totalWidth - margin.right/4;
      if (chartWidth < this.totalWidth) {
        this.isScroll = true;

        this.svgScroll.attr("class", "scrollchart-container");

        this.scrollChart.append("rect")
          .attr("class", "mover")
          .attr("x", 0)
          .attr("y", 0)
          .attr("height", "20")
          .attr("width", Math.round(scrollWidth))
          .attr("pointer-events", "all")
          .attr("cursor", "ew-resize")
          .call(d3.drag().on("drag", this.display));
      } else {
        this.isScroll = false;
        this.svgScroll.attr("class", "no-scroll");
      }

      if (!(this.globalBarWidth == this.maxZoom && !this.isScroll)) {
        const zIn = this.zoomIn;
        const zOut = this.zoomOut;
        this.svg.on("mousewheel.zoom", function(event) {
          if (event.deltaY < 0) {
            zIn();
          } else if (event.deltaY > 0) {
            zOut();
          }
          event.preventDefault();
        });
      } else {
        this.svg.on('mousewheel.zoom', null)
      }
    },
    zoomIn() {
      this.globalBarWidth += 2;
      this.globalBarWidth = this.globalBarWidth > this.maxZoom ? this.maxZoom : this.globalBarWidth;
      this.drawFunction();
    },
    zoomOut() {
      this.globalBarWidth -= 2;
      this.globalBarWidth = this.globalBarWidth < this.minZoom ? this.minZoom : this.globalBarWidth;
      this.drawFunction();
    }
  },
  created() {
    this.id = "uid" + this._uid;
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    jquery(".group-tooltip").remove();
    if (this.chart) {
      this.chart.remove();
    }
    if (this.scrollChart) {
      this.scrollChart.remove();
    }
    window.removeEventListener("resize", this.drawFunction);
  },
};
</script>

<style lang="scss">
#svg-container {
  height: 100%;
}
</style>